.icon16x16 {
  width: 16px;
  height: 16px;
}

.icon20x20 {
  width: 20px;
  height: 20px;
}

.icon40x40 {
  width: 40px;
  height: 40px;
}
